import { connect } from 'react-redux';
import { prop } from 'ramda';
import { compose, withHandlers } from 'recompose';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';

import { sendCharacteristicView } from '../../services/tracking';
import { toggleOlxProPopup, selectCharacteristic } from '../../../core/actions';
import Characteristics from './Characteristics';

const configureHandlers = withHandlers({
  handleClick: ({ funnelId }) => (posName, link, product) => {
    sendCharacteristicView(posName, link, product, funnelId);
  },
});

const mapStateToProps = state => ({ funnelId: prop('funnelId', getPOSData(state)) });

export default compose(
  connect(mapStateToProps, { openModal: toggleOlxProPopup, selectCharacteristic }),
  configureHandlers,
)(Characteristics);
